import React, { useContext } from 'react';
import LiteRouteFrame from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/ResponsiveFrame/LiteRouteFrame';
import useAppLayout from 'state/hooks/use-app-layout';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { LiteRouteActivityContext } from 'state/providers/LiteRouteActivityProvider';

type Props = {
  loadedData?: () => any;
};

const LiteRouteActivity: React.FC<Props> = ({ loadedData = () => null }) => {
  const { containerHeight } = useAppLayout();
  const [state] = useContext(LiteRouteActivityContext);
  const classes = useStyles({ containerHeight });

  return (
    <Box className={classes.root}>
      <LiteRouteFrame
        key={`${state?.activity?.url ?? ''}`}
        onLoad={loadedData}
        src={state?.activity?.url ?? ''}
        title={state?.activity?.title ?? ''}
      />
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
}));

export default LiteRouteActivity;
